// src/services/GlobalUserService.ts
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../config/firebase';
import { User } from '../types';

export class GlobalUserService {
    /**
     * Get user's global data (pollid, VIP status)
     */
    static async getGlobalUserData(userId: string): Promise<{ pollid: number; isVip: boolean }> {
        const userRef = doc(firestore, 'users', userId);
        const userDoc = await getDoc(userRef);

        if (!userDoc.exists()) {
            return { pollid: 0, isVip: false };
        }

        const data = userDoc.data() as User;
        return {
            pollid: data.pollid || 0,
            isVip: data.isVip || false
        };
    }
        }
